import { Button, MenuItem, Select, Stack, TextField } from '@mui/material';
import moment from 'moment';
import { useEffect, useState } from 'react';
import DatesPicker from 'src/components/mui/datespicker';
import { boxStyle, MenuFilter, menuStyle } from './MenuStyle';

const MenuLead = props => {
    const { setFilters, setReload } = props;
    const fields = ['국가연구소', '제조업', '학교', '도소매'];
    const [ranges, setRanges] = useState('def');
    const [checkedField, setCheckedField] = useState(fields);
    const [daterange, setDateRange] = useState({});
    const [keyword, setKeyword] = useState('mb_name');
    const [q, setQ] = useState('');

    useEffect(() => {
        setFilters({
            mb_type: checkedField.join(','),
            startDate: daterange.startdate? moment(daterange.startdate).format('YYYY-MM-DD 00:00:00'): '',
            endDate: daterange.enddate? moment(daterange.enddate).format('YYYY-MM-DD 23:59:59'): '',
            keyword: keyword,
            q: q,
        });
    }, [checkedField, daterange, keyword, q]);

    return (
        <div style={boxStyle}>
            <MenuFilter title={'업체분류'} items={fields} checkedItems={checkedField} setCheckedItems={setCheckedField} />
            <Stack direction="row" spacing={8}>
                <div style={menuStyle}>
                    <h5 style={{ width: '5rem', minWidth: '4rem' }}>가입일자</h5>
                    <DatesPicker daterange={daterange} setDateRange={setDateRange} ranges={ranges} size='small' />
                </div>
                <div style={menuStyle}>
                    <h5 style={{ width: '4rem' }}>검색</h5>
                    <Select
                        labelId="target-select-label"
                        id="target-select"
                        value={keyword}
                        onChange={(e) => setKeyword(e.target.value)}
                        sx={{ minWidth: 120 }}
                        size='small' >                            
                            <MenuItem value="mb_name">이름</MenuItem>
                            <MenuItem value="mb_company">업체명</MenuItem>
                            <MenuItem value="mb_email">이메일</MenuItem>
                            <MenuItem value="mb_charge">영업담당</MenuItem>
                    </Select>
                    <TextField
                        value={q}
                        label='검색어'
                        id='search'
                        onChange={(e) => setQ(e.target.value)}
                        placeholder='검색어를 입력해주세요'
                        size='small'
                        sx={{ minWidth: 200, marginLeft: '1rem' }}
                    />
                    <Button variant="contained" onClick={() => setReload(reload => reload+1)} sx={{ marginLeft: '1rem' }}>검색</Button>
                </div>
            </Stack>
        </div>
    )
}

export default MenuLead